/* eslint-disable class-methods-use-this */
import { Context, GenericObject } from 'moleculer';

import Services from './services';

export default class FbxServicesContext<P = unknown, M extends object = {}, L = GenericObject, C = Record<string, unknown> | undefined> extends Context<P, M, L> {
  get moduleContext(): C {
    return Services.instance.context as C;
  }
}
